import styled from 'styled-components';
import ButtonIcon from 'components/ButtonIcon';
import UserAvatar from 'components/UserAvatar';
import Note from 'components/icons/note';
import {
    GREEN_100, GREEN_500, GREY_500, PURPLE_100, PURPLE_500,
} from '../../../../../constants';

export const CellWrapper = styled.div`
    display: flex;
    align-items: center;
    height: 100%;
    padding: 0 10px;
    overflow: hidden;
    text-overflow: ellipsis;
`;

export const ActionsCellWrapper = styled(CellWrapper)`
    justify-content: flex-end;
    padding: 0 2rem 0 0;
    gap: 0.5rem;
`;

export const PhoneCellWrapper = styled(CellWrapper)`
    display: flex;
    padding: 0.6875rem 1.25rem;
    align-items: center;
    gap: 0.625rem;
    flex: 1 0 0;
`;

export const Icon = styled(UserAvatar)<{ primary: boolean }>`
    display: flex;
    width: 2.375rem;
    height: 2.375rem;
    justify-content: center;
    align-items: center;
    border: 4px solid transparent;

    & > svg {
        width: 1.2rem !important;
        height: auto !important;
        flex-shrink: 0;
    }
    background: ${GREEN_100};
    color: ${GREEN_500};

    &:hover {
        color: ${GREEN_500};
    }
     
    ${({ primary }) => primary && `
        border: 4px solid ${PURPLE_500};

        background: ${PURPLE_100};
        color: ${PURPLE_500};

        &:hover {
            color: ${PURPLE_500};
        }
    `}
`;

export const Label = styled.h2`
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    color: ${GREY_500};
    font-weight: 300;
    font-size: 0.9375rem;
    padding: 0;
    line-height: 1.25rem;
`;

export const NoteIcon = styled(Note)`
    width: 1rem !important;
    height: 1rem !important;
    font-size: 1rem !important;
    cursor: pointer;
    :hover {
        color: ${PURPLE_500};
    }
`;
export const TooltipButton = styled(ButtonIcon)`
    width: 1rem;
    height: 1rem;
    border-radius: 1rem;
    border: none;
    padding: 0;
    margin: 0;

    svg {
        width: 1rem !important;
        height: 1rem !important;
        font-size: 1rem !important;
    }
`;

export const TooltipContainer = styled.div`
    width: 280px;
    display: flex;
    padding: 0.25rem 0.75rem;
    align-items: flex-start;
    gap: 0.625rem;
    flex: 1 0 0;
    align-self: stretch;
    text-align: left;
`;
